'use strict';

import React, { PropTypes } from 'react';
import { hashHistory } from 'react-router';
import ScrollerComponent from './PreciseScrollerComponent';
import ClockComponent from './ClockComponent';
import YesNoComponent from './YesNoComponent';
import LyricsComponent from './LyricsComponent';
import _ from 'lodash';
// import Draggable from 'react-draggable';
import ChannelEntryComponent from './ChannelEntryComponent';

// styles
require('vendor/pure/grids.css');
require('styles/MainChannel.css');

// const isFF = !!window.sidebar;

class MainChannelComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static propTypes = {
    channel: PropTypes.number.isRequired,
    shortName: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    poster: PropTypes.string,
    largePoster: PropTypes.string,
    audioManager: PropTypes.object.isRequired,
    streamManager: PropTypes.object.isRequired,
    track: PropTypes.string,
    channelList: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.array
    ]).isRequired
  }

  getStream(name) {
    return this.props.streamManager.iteratorFor(name);
  }

  changeChannel(channel) {
    hashHistory.push(`/channels/${channel}`);
  }

  render() {
    const channelDataScroller = (label, name, dir) => {
      if (_.isUndefined(dir)) {
        dir = 'left';
      }
      return (
        <tr>
          <td className="field-name">{label}:</td>
          <td>
            <ScrollerComponent
              className="channel-data-scroller"
              stream={this.getStream(name)}
              duration={10}
              gap={10}
              direction={dir} />
          </td>
        </tr>
      );
    };

    const posterStyle = (_.isUndefined(this.props.poster)
      || this.props.poster === '/images/') ?
      {visibility: 'hidden', opacity: 0} : {};


    let lightBoxContent = null;

    const toggleLightBox = () => {
      this.setState((state) => {
        return {showLightBox: !state.showLightBox};
      });
    };

    const lightBoxClasses = 'light-box' +
      (this.state.showLightBox ? ' show' : '');
    const lightBoxContentClasses = 'light-box-content' +
      (this.state.showLightBox ? ' show' : '');

    if (this.props.poster) { lightBoxContent = (
        <img src={this.props.largePoster}
             onClick={toggleLightBox} />
      );
    }

    const clickable = this.props.channel !== 333 && this.props.channel !== 999;
    const channelList = (
      <ul className="channel-list">
        {_.map(this.props.channelList, (channel) =>
          <li key={channel.channel}>
          {clickable ?
            (<a href={`#/channels/${channel.channel}`}>
            {channel.name.toLowerCase()}
            </a>) :
            channel.name.toLowerCase()
           }
          </li>
        )}
      </ul>
    );

    let middleContent = <ChannelEntryComponent
      channel={this.props.channel}
      changeChannel={this.changeChannel} />;
    let bottomStyle = {};

    if (this.props.channel % 333 === 0 && this.props.channel > 0) {
      middleContent = <LyricsComponent
                        channel={this.props.channel}
                        track={this.props.track} />;
      bottomStyle.display = 'none';
    }

    return (
      <div className="main-channel">
        <div className={lightBoxClasses} onClick={toggleLightBox}></div>
        <div className={lightBoxContentClasses} onClick={toggleLightBox}>
          {lightBoxContent}
        </div>
        <div className="pure-g">
          <div className="pure-u-1-1">
            <p>You are now listening to</p>
            <table className="channel-table">
              <tbody>
                {channelDataScroller('Channel Number', 'channel')}
                {channelDataScroller('Sounder', 'shortName', 'right')}
                {channelDataScroller('Name', 'name')}
              </tbody>
            </table>
          </div>
        </div>
        <div className="pure-g middle-section">
          <div className="pure-u-1-3">
            <div className="poster-container" style={posterStyle}>
              <p>Artwork:</p>
              <p>
                <img src={this.props.poster}
                     className="poster"
                     onClick={toggleLightBox} />
              </p>
            </div>
          </div>
          <div className="pure-u-1-3">
            {middleContent}
          </div>
          <div className="pure-u-1-3">
            {this.props.channelList ? channelList : null}
          </div>
        </div>
        <div className="pure-g bottom-section" style={bottomStyle}>
          <div className="pure-u-1-3">
            <div className="pure-g clocks">
              <div className="pure-u-1-3">
                <ClockComponent label="We" className="clock" />
              </div>
              <div className="pure-u-1-3">
                <ClockComponent label="Share" className="clock" />
              </div>
              <div className="pure-u-1-3">
                <ClockComponent label="Time!" className="clock" />
              </div>
            </div>
          </div>
          <div className="pure-u-1-3">
            <div className="short-name-scroller-container">
              <ScrollerComponent
                className="short-name-scroller"
                stream={this.getStream('shortName')}
                duration={3}
                gap={10} />
            </div>
          </div>
          <div className="pure-u-1-3">
            <div className="yesno-container">
              <YesNoComponent width={300} height={225} velocity={100} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

MainChannelComponent.displayName = 'MainChannelComponent';

export default MainChannelComponent;



// WEBPACK FOOTER //
// ./src/components/MainChannelComponent.js